import http from "./http";

/* ADD USER */
export const addUser = async (data) => {
  const res = await http.post("add_user", data);
  return res.data;
};

/* GET ALL USERS */
export const getUsers = async () => {
  const res = await http.get("get_all_user", { params: { limit: 1000 } });
  return res.data;
};

/* SEARCH USERS (server-side, supports ?search=&page=) */
export const searchUsers = async (query = "", page = 1) => {
  const params = new URLSearchParams({ page });
  if (query.trim()) params.set("search", query.trim());
  const res = await http.get(`add_user?${params.toString()}`);
  return res.data;
};

/* GET SINGLE USER */
export const getUserById = async (id) => {
  const res = await http.get(`add_user?id=${id}`);
  return res.data;
};

/* UPDATE USER */
export const updateUser = async (id, data) => {
  const res = await http.put(`add_user?id=${id}`, { id, ...data });
  return res.data;
};

/* DELETE USER */
export const deleteUser = async (id) => {
  const res = await http.delete("add_user", {
    data: { id },
  });
  return res.data;
};